// extracted by mini-css-extract-plugin
export var messageSideLeft = "_jx-1";
export var messageSideRight = "_jx-2";
export var subscribeToBackInStockBubbleContainer = "_jx-0";